export const TickMark = (props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='19'
      height='15'
      viewBox='0 0 19 15'
      fill='none'
      {...props}
    >
      <path
        d='M6.69167 14.8167L0.00750732 8.1325V4.94917L6.70001 11.6417L18 0.5L18.0542 3.55417L6.69167 14.8167Z'
        fill='var(--colorTextBrand)'
      />
    </svg>
  );
};
